export const environment = {
  production: true,

  //API Base URL-s
  apiUrl: '/api/',
  apiBaseUrl: '/api/filesystem-manager/vue-finder',

  //Feature flags
  gridSystemEnabled: true,

  // TAO parent origins allowed to send postMessage logout events.
  // Add each tenant's frontend origin here (e.g. 'https://mlsz-tao.example').
  allowedParentOrigins: ['*.flexinform.hu'] as string[],

  sentry: {
    dsn: 'https://a911e7af25124ce58983d9510dd578fe@bugsink.intranet.flexinform.hu/9',
    environment: 'production',
    release: '',
    debug: false,
    sampleRate: 1,
  },
};
